import { http } from './http'

export const createOrder = (box_token, offer_id, return_url, additionalData = {}) => {
  return http().post('/api/orders', { box_token, offer_id, return_url, ...additionalData })
}

export const retryOrder = (box_token, order_id, return_url, additionalData = {}) => {
  return http().post('/api/orders/retry', { box_token, order_id, return_url, ...additionalData })
}

export const getOrder = (orderId, box_token) => {
  return http().get(`/api/orders/${orderId}`, { params: { box_token } })
}

export const getOrderPayload = (orderId, params) => {
  return http().get(`/api/orders/${orderId}/payload`, { params })
}

export const getOrderRedirectUrl = (orderId, params) => {
  return http().get(`/api/orders/${orderId}/redirect_url`, { params })
}
